/* eslint-disable one-var */
import newIcon from '../../00-utilities/icon';
import DropdownBase from './DropdownBase';

/**
 * @fileOverview Dropdown for nav elements
 * @author Selectra Front End Team
 * @version 1.0.0
 * @requires /src/js/01-atoms/DropdownBase.js
 * @requires Polyfill:NodeList.forEach
 * @requires Polyfill:Element.classList
 */


/**
 * Represents a navigation dropdown
 * @extends DropdownBase
 * @exports
 */
export default class DropdownList extends DropdownBase {
  /**
   * Create a navigation dropdown
   * @param { object } element - A reference to the nav or select object
   * @param { object } options - A configuration object
   */
  constructor( baseElement, options, index, manager ) {
    super( baseElement, options, index, manager );

    this.type = 'list';

    this._build();
    this._buildCommon();
    this._setCommonEventListeners();
    this._setEventListeners();

  }


  /**
   * Set-up DropdownList
   * @private
   */
  _build() {

    /**
     * Replace the link element with a new one which includes an icon
     * @param { object } item   -- Block element reference (li)
     */
    function populateItem( item ) {

      const
        itemLink = item.querySelector( 'a' ),
        dataLeft = item.dataset[ 'imageLeft' ],
        dataRight = item.dataset[ 'imageRight' ];

      itemLink.setAttribute( 'tabindex', '-1' );

      if ( !dataLeft && !dataRight ) {
        return;
      }

      const
        newElement = item.cloneNode( false ),
        newItemText = document.createElement( 'span' ),
        newLink = itemLink.cloneNode( false );

      newLink.setAttribute( 'tabindex', '-1' );
      newElement.appendChild( newLink );

      newItemText.textContent = item.textContent;

      if ( dataLeft ) {
        const itemIcon = newIcon( dataLeft, [ 'icon--left' ]);
        newLink.appendChild( itemIcon );
        newLink.appendChild( newItemText );
      } else if ( dataRight ) {
        const itemIcon = newIcon( dataRight, [ 'icon--right' ]);
        newLink.appendChild( newItemText );
        newLink.appendChild( itemIcon );
      }

      item.parentElement.replaceChild( newElement, item );

    }

    // Trigger
    this.trigger = this.baseEl.querySelector( '.dropdown__trigger' );

    // Set disabled class
    this.list.isActive = !this.baseEl.hasAttribute( 'disabled' );
    if ( !this.list.isActive ) {
      this.baseEl.classList.add( 'dropdown--disabled' );
    }

    // List
    this.list.el = this.baseEl.querySelector( '.dropdown__content' );

    Array.from( this.list.el.children ).forEach( populateItem );

    this.list.html.appendChild( this.list.el );

  }

  /**
   * Activate link contained in selected list element
   */
  _activateSelected() {

    const link = this.list.selected.querySelector( 'a' );

    switch ( link.getAttribute( 'target' )) {
    case '_self':
    default:
      window.location.href = link.href;
      break;
    case '_blank':
      window.open( link.href );
      break;
    }

    this.hideList();
    this.manager.activeDropdown = null;

  }


  /**
   * Set select specific eventListeners
   */
  _setEventListeners() {
    this.baseEl.addEventListener( 'mousedown', e => {

      e.preventDefault();
      this.list.selected = e.target;

      if ( this.list.selected.nodeName !== 'UL' ) {

        while ( this.list.selected.nodeName !== 'LI' ) {
          this.list.selected = this.list.selected.parentElement;
        }

        this._activateSelected();

        this.list.selected = null;

      }

    });
  }

}
